var _rect, _g, _g2, _g3, _g4, _rect2, _path, _path2, _path3, _path4, _path5, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgNewsletter = function SvgNewsletter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 81,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 66.383,
    rx: 4.852,
    fill: "url(#Newsletter_svg__paint0_linear_14582_121266)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Newsletter_svg__filter0_d_14582_121266)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.851,
    cy: 7.081,
    r: 1.77,
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Newsletter_svg__filter1_d_14582_121266)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.162,
    cy: 7.081,
    r: 1.77,
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Newsletter_svg__filter2_d_14582_121266)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.472,
    cy: 7.081,
    r: 1.77,
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Newsletter_svg__filter3_d_14582_121266)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.226,
    y: 4.868,
    width: 69.923,
    height: 3.983,
    rx: 1.991,
    fill: "#EFF4FF"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.966,
    y: 14.604,
    width: 41.157,
    height: 44.255,
    rx: 3.882,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.33 17.702h12.157M56.204 23.096h19.408",
    stroke: "#434393",
    strokeWidth: 1.456,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.839 28.766a2.638 2.638 0 012.608 2.306c0 .106.026.185.026.291v12.243h-.026v34.342c0 1.431 1.17 2.624 2.635 2.624h32.52c1.437 0 2.634-1.166 2.634-2.624V31.39c0-.106 0-.186-.026-.292a2.618 2.618 0 00-2.608-2.305l-37.763-.027z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.402 39.83h12.156M68.153 50.386h6.86M68.153 61.809h6.86M77.89 50.386h16.153M77.89 61.809h16.153M68.276 45.224h19.407M68.276 56.647h19.407",
    stroke: "#C8C8FB",
    strokeWidth: 1.456,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.055 80.545h37.31c1.437 0 2.635-1.166 2.635-2.624v-5.008c0-1.14-.931-2.067-2.076-2.067H68.765a2.074 2.074 0 00-2.076 2.067v5.008c0 1.458-1.197 2.624-2.634 2.624z",
    fill: "url(#Newsletter_svg__paint1_linear_14582_121266)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.204 31.443v7.95c0 1.139.932 2.066 2.076 2.066h3.167V31.39c0-.105 0-.185-.027-.29a2.605 2.605 0 00-2.528-2.333c-1.464-.026-2.688 1.193-2.688 2.677z",
    fill: "url(#Newsletter_svg__paint2_linear_14582_121266)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Newsletter_svg__clip0_14582_121266)",
    fill: "#757FDA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.456 43.076l5.63-8.239c.334-.515 1.05-.592 1.511-.18l4.249 3.965a.998.998 0 001.459-.129l7.449-8.83c.409-.516 1.203-.516 1.586.025l8.268 13.414c.486.669 0 1.596-.82 1.596l-28.513-.052c-.794 0-1.28-.9-.82-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.256 33.318a2.49 2.49 0 002.482-2.497 2.49 2.49 0 00-2.482-2.498 2.49 2.49 0 00-2.483 2.498 2.49 2.49 0 002.483 2.497z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Newsletter_svg__filter0_d_14582_121266",
    x: 5.14,
    y: 4.34,
    width: 7.422,
    height: 7.422,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.97
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.97
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14582_121266"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_14582_121266",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Newsletter_svg__filter1_d_14582_121266",
    x: 10.451,
    y: 4.34,
    width: 7.422,
    height: 7.422,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.97
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.97
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14582_121266"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_14582_121266",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Newsletter_svg__filter2_d_14582_121266",
    x: 15.761,
    y: 4.34,
    width: 7.422,
    height: 7.422,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.97
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.97
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14582_121266"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_14582_121266",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Newsletter_svg__filter3_d_14582_121266",
    x: 23.285,
    y: 3.898,
    width: 73.805,
    height: 7.865,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.97
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.97
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14582_121266"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_14582_121266",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Newsletter_svg__paint0_linear_14582_121266",
    x1: 52,
    y1: 0,
    x2: 52,
    y2: 66.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A95F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D458D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Newsletter_svg__paint1_linear_14582_121266",
    x1: 84.018,
    y1: 78.889,
    x2: 84.018,
    y2: 65.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBC1EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939CF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Newsletter_svg__paint2_linear_14582_121266",
    x1: 58.824,
    y1: 39.293,
    x2: 58.824,
    y2: 22.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEAEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A391D4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Newsletter_svg__clip0_14582_121266"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(13.277 28.323)",
    d: "M0 0h30.536v16.375H0z"
  })))));
};
export default SvgNewsletter;